import { Injectable } from '@angular/core';
import { ApiKey } from '../components/account-settings/api-keys';
import { API } from './api';
import { BaseProvider } from './base';

@Injectable()
export class APIKeyProvider extends BaseProvider {
    private keys: ApiKey[] = [];
    constructor(private api: API) {
        super();
    }

    public async load(): Promise<void> {
        try {
            const response = await this.api.get('keys');
            this.keys = response.message.map(result => {
                return {
                    id: result.keyIdentifier,
                    name: result.name,
                    dateAdded: result.date_added,
                    active: result.date_deactivated ? false : true
                };
            });
        } catch (err) {
            throw err;
        }
    }

    /**
     * Accessor for the API keys loaded in the provider
     *
     * @param returnInactiveKeys whether we want to return the inactive keys associated with the user
     *
     * @return ApiKey[]
     */
    public getKeys(returnInactiveKeys: boolean = true): ApiKey[] {
        return returnInactiveKeys ? this.keys : this.keys.filter(key => key.active);
    }
}



// WEBPACK FOOTER //
// ./src/providers/apikey.ts